import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FACET_COLORS } from 'Theme';
import PropTypes from 'prop-types';
import {
  FDIcon, FDTooltip, FDStack,
} from '@facet-wealth/design';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import Typography from 'Components/UI/Typography';

const useStyles = buildUseStyles('InsightChip', (() => ({
  root: {},
  chip: {},
  icon: {},
  insightIconContainer: {
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})));

const getIconType = (resource) => {
  switch (resource.attr('iconType')) {
    case 'arrow_downward':
      return 'keyboardArrowDown';
    case 'arrow_upward':
      return 'keyboardArrowUp';
    case 'check':
      return 'check';
    default:
      return '';
  }
};

const getColor = (resource) => {
  switch (resource.attr('status')) {
    case 'SUCCESS':
      return FACET_COLORS.completeGreen.color;
    case 'WARN':
      return FACET_COLORS.yellow.color;
    case 'ERROR':
      return FACET_COLORS.red.color;
    default:
      return FACET_COLORS.blueGray4.color;
  }
};

const InsightChip = ({
  insightResource,
}) => {
  const classes = useStyles();

  const color = getColor(insightResource);
  const iconType = getIconType(insightResource);

  return (
    <FDTooltip title={insightResource.attr('description')} placement="bottom">
      <Box width={'150px'}>
        {insightResource.attr('hidden') === 'false' && (
          <FDStack alignItems="center" spacing={0.5} justifyContent="flex-start">
            <div className={classes.insightIconContainer} style={{ backgroundColor: color }}>
              <FDIcon icon={iconType} color="white" size="sm" />
            </div>
            <div style={{ color }}>
              <Typography variant="h5" weight="bold" color={color}>
                {insightResource.attr('name') ?? ''}
              </Typography>
            </div>
          </FDStack>
        )}
      </Box>
    </FDTooltip>
  );
};

InsightChip.defaultProps = {
};

InsightChip.propTypes = {
  insightResource: PropTypes.object.isRequired,
};

export default InsightChip;
